import { z } from 'zod';

export const geoPointSchema = z.object({
  lat: z.number(),
  lng: z.number(),
});

export type GeoPoint = z.infer<typeof geoPointSchema>;
